import * as types from './mutation-types';
import router from '../router';
import { Auth, Me } from '../api';
import TokenManager from '../utils/TokenManager';

export default {
  prepareByCampaignCode: ({ commit }, campaignCode) => {
    return Auth.prepare({ campaignHash: campaignCode })
      .then(result => {
        commit(types.SET_CURRENT_CAMPAIGN, {
          ...result.data.campaign,
          code: campaignCode
        });
        commit(types.SET_SIGNUP_TOKEN, result.result.auth.token);
        return Promise.resolve(result.data);
      })
      .catch(ApiError => {
        return Promise.reject(ApiError);
      });
  },

  setCurrentCampaign: ({ commit }, campaign) => {
    commit(types.SET_CURRENT_CAMPAIGN, campaign);
  },

  setApplicantData: ({ commit }) => {
    return Me.fetchDataAtOnce().then(data => {
      commit(types.SET_APPLICANT, data.me);
    });
  },

  /**
   * @param Object authInfo {email, password} などの認証に必要な情報
   * @param temporaryToken prepare_by_hash 実施時に取得したtoken
   */
  login: ({ commit }, authInfo) => {
    return Auth.login(authInfo).then(data => {
      TokenManager.set(data.result.auth.token);
      const applicant = data.me;
      commit(types.SET_APPLICANT, applicant);
    });
  },

  backToTop: ({ commit }) => {
    commit(types.INIT_STATE);
  },

  fetchApiEnums: ({ commit }) => {
    Me.fetchAllEmum()
      .then(data => {
        let newObj = {};
        for (let type in data) {
          newObj[type] = {};
          for (let key in data[type]) {
            newObj[type][data[type][key].code] = data[type][key];
          }
        }
        commit(types.SET_API_ENUMS, newObj);
      })
      .catch(ApiError => {
        if (ApiError.authExpired) {
          const code = this.state.campaignCode;
          commit(types.INIT_STATE);
          router.push('cp/' + code + '/login');
        } else {
          return Promise.reject(ApiError);
        }
      });
  }
};
